import React, { useState } from "react"
import {
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
} from "reactstrap"
import { useTranslation } from "react-i18next"

interface PreferredTimesModalProps {
  isOpen: boolean
  toggle: () => void
  onConfirm: (time: string) => void
  currentTime?: string
}

const timeOptions = [
  { value: "earlyMorning", label: "coupons_earlyMorning" },
  { value: "beforeNoon", label: "coupons_beforeNoon" },
  { value: "afternoon", label: "coupons_afternoon" },
  { value: "evening", label: "coupons_evening" },
  { value: "night", label: "coupons_night" },
]

export const PreferredTimesModal: React.FC<PreferredTimesModalProps> = ({
  isOpen,
  toggle,
  onConfirm,
  currentTime = "earlyMorning",
}) => {
  const { t } = useTranslation()
  const [selectedTime, setSelectedTime] = useState(currentTime)

  // Sync selectedTime with currentTime whenever modal opens or currentTime changes
  React.useEffect(() => {
    if (isOpen) {
      setSelectedTime(currentTime)
    }
  }, [isOpen, currentTime])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onConfirm(selectedTime)
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle} tag="h3">
        <h4 className="fw-semibold font-size-24">
          {t("coupons_preferredTimesForRefilling")}
        </h4>
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup tag="fieldset">
            {timeOptions.map(option => (
              <div
                key={option.value}
                className="d-flex align-items-center mb-3 cursor-pointer"
                onClick={() => {
                  console.log("Time option clicked:", option.value)
                  setSelectedTime(option.value)
                }}
              >
                <Input
                  type="radio"
                  name="preferredTime"
                  value={option.value}
                  checked={selectedTime === option.value}
                  onChange={(e) => setSelectedTime(e.target.value)}
                  className="me-2"
                  style={{ cursor: 'pointer' }}
                />
                <span className="font-size-16">{t(option.label)}</span>
              </div>
            ))}
          </FormGroup>
          <Row>
            <Col>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="submit"
                  className="btn bg-gradiant-blue text-white border-0"
                >
                  {t("common_confirm")}
                </button>
                <button
                  onClick={toggle}
                  type="button"
                  className="btn btn-cancel text-cyan border border-cyan"
                >
                  {t("common_cancel")}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}
